import React, { Component } from 'react';
import {getNotes} from './getNotes.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import { connect } from "react-redux";
import {moveKey} from 'utils/objectMover.js';
import CommentsComponent from './CommentsComponent.js';
import TaggerComponent from './TaggerComponent.js';
import UserMix from 'repos/UserMix.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {setSpotlightTracks, setUserHasEditsToSave, setCurrentUserMix} from 'actions/index.js';
import PlayButton from 'components/user/PlayButton.js';
import PatternButtons from 'components/user/PatternButtons.js';
import PulseLoader from 'react-spinners/PulseLoader'
import {SPOTLIGHT, MIXES} from 'constants/user-view-modes.js';
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import Colors from 'components/Colors.js';
const colors = new Colors();

/**
 * A playable track component representing a sequence
 */
class SpotlightTrack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sequence: this.props.sequence,
            userName: undefined,
            showComments: false,
            showTagger: false,
            numNotes: undefined
        };
        this.loadDate();
        this.loadUser();
        this.loadNumNotes();
    }

    async loadNumNotes() {
        let notes = await getNotes(this.props.sequence.id, false);
        if (notes === undefined) {
            return;
        }

        this.setState({
            numNotes: notes.length
        });
    }

    async loadUser() {
        let user = await this.props.ethereum.users.getUserName(this.props.sequence.user);
        this.setState({userName: user});
    }
    
    async loadDate(sequence=this.props.sequence) {
        let block = await this.props.ethereum.web3.eth.getBlock(sequence.blockNumber);
        let date = new Date(block.timestamp * 1000).toLocaleString();

        this.setState({date: date});
    }

    onClickDelete() {
        if (this.props.isPlayable) {
            this.props.unloadTrack();
            return;
        }
        if (this.props.sequencerEngine !== undefined) {
            this.props.sequencerEngine.dispose();
        }
        this.props.onClickDelete();
    }

    onClickTrackName() {
        if (this.props.isPlayable) {
            return;
        }

        if (this.props.sequencerEngine !== undefined) {
            this.props.unloadTrack();
        } else {
            this.props.loadTrack();
        }
    }

    onChangeVolume(v) {
        this.props.sequencerEngine.setMasterVolume(v);
        this.setState(this.state);
    }

    isLoaded() {
        if (!this.props.isPlayable) {
            return false;
        }
        return this.props.loadingSequence !== undefined &&
            !this.props.loadingSequence[this.state.sequence.id] &&
            this.props.sequencerEngine !== undefined;
    }

    onClickEdit() {
        this.props.onEditSequence(this.props.sequencerEngine);
    }

    onClickComment() {
        this.setState({showComments: true});
    }

    onClickTag() {
        this.setState({showTagger: true});
    }

    getSequenceName() {
        return this.state.sequence ? this.state.sequence.name : '';
    }

    onDragOver(e) {
        e.preventDefault();
    }

    onDragStart(e) {
        if ((this.props.viewMode !== SPOTLIGHT && this.props.viewMode !== MIXES) ||
            this.isLoaded()) {
            e.preventDefault();
            return;
        }
        this.props.setDraggingSpotlightTrack(this.props.sequence);
    }

    onDrop(e) {
        if ((this.props.viewMode !== SPOTLIGHT && this.props.viewMode !== MIXES)
            || this.isLoaded()) {
            e.preventDefault();
            return;
        }
        let tracks = [... this.props.tracks];
        let i = tracks.map(x => x.id).indexOf(
            this.props.draggingSpotlightTrack.id);
        if (i < 0) {
            return;
        }
        tracks = moveKey(i, this.props.i, tracks);

        // either its the spotlight or the mixes view
        if (this.props.viewMode === SPOTLIGHT) {
            // set the spotlight tracks 
            this.props.setSpotlightTracks(Object.keys(tracks).map(x => tracks[x]));
        } else {
            // set the current user mix tracks 
            let userMix = new UserMix().fromJson(this.props.currentMix);
            userMix.tracks = Object.values(tracks);
            this.props.setCurrentUserMix(userMix.getJson());
        }
        this.props.setUserHasEditsToSave(true);
    }

    render() {
        let isLoading = this.props.sequencerEngine === undefined ? false :
            this.props.loadingSequence === undefined ? true :
            this.props.loadingSequence[this.state.sequence.id];
        let style = {
        };

        if (this.props.isEditing) {
            style['backgroundColor'] = colors.brighten(
                colors.getColorForHash(this.props.sequence.id), 1);
        }

        return (
            <div
              onDragStart={(e) => this.onDragStart(e)}
              onDragOver={(e) => this.onDragOver(e)}
              onDrop={(e)=>this.onDrop(e)}                   
              draggable
              style={style}
              className={this.isLoaded() ? "loaded spotlight-track" : "spotlight-track"}>
              {this.props.isEditing || this.isLoaded() ? 
                <div onClick={() => this.onClickDelete()} className="delete-button">x</div> : ''}
              <div className="volume-pane">
                {this.isLoaded () ?
                    <ReactBootstrapSlider
                          value={this.props.masterVolume}
                          change={(e) => this.onChangeVolume(e.target.value)}
                          step={0.1}
                          className="spotlight-fader"
                          max={6}
                          min={-40}
                          orientation="vertical"
                          reversed={true}
                      />  : ''}
              </div>
              <div className="track-pane">
                <div onClick={() => this.onClickTrackName()} className="track-name">
                  {this.getSequenceName()}
                </div>
                {this.isLoaded() ?
                    <PlayButton play={this.props.play} isPlaying={this.props.isPlaying} sequencerEngine={this.props.sequencerEngine}/>
                    : ''}
                <div className="clear-fix"/>
                <div className="date-and-name">
                  <div className="track-user-name">{this.state.userName}</div>
                  <div className="track-date">
                    {this.state.date ? this.state.date : ''}
                  </div>
                </div>
                <PulseLoader
                  sizeUnit={"px"}
                  size={10}
                  color={'#42f4f1'}
                  loading={isLoading}
                  />
                {this.isLoaded() ?
                    <PatternButtons
                      currentPattern={this.props.currentPattern}
                      sequencerEngine={this.props.sequencerEngine}/> : ''}
             </div>
             <ConditionedComponent condition={this.isLoaded() && !this.state.showComments}>
               <div onClick={() => this.onClickEdit()} className="edit-button red-button common-button">
                 Edit 
               </div>
               <div onClick={() => this.onClickTag()} className="edit-button green-button common-button">
                 Tag
               </div>
               <div onClick={() => this.onClickComment()} className="edit-button green-button common-button">
                 {this.state.numNotes ? this.state.numNotes + ' Notes' : 'Notes'}
               </div>
             </ConditionedComponent>
             <div className="clear-fix"></div>
             <ConditionedComponent condition={this.state.showComments}>
               <CommentsComponent
                 onHide={() => this.setState({showComments: false})}
                 userId={this.props.userId}
                 sequence={this.props.sequence}/>
             </ConditionedComponent>
             <ConditionedComponent condition={this.state.showTagger}>
               <TaggerComponent
                 onHide={() => this.setState({showComments: false})}
                 sequence={this.props.sequence}/>
             </ConditionedComponent>
           </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        masterVolume: state.sequencer.masterVolumes[props.sequence.id],
        currentMix: state.user.currentMix,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setSpotlightTracks: (tracks) => dispatch(setSpotlightTracks(tracks)),
        setUserHasEditsToSave: (flag) => dispatch(setUserHasEditsToSave(flag)),
        setCurrentUserMix: (mix) => dispatch(setCurrentUserMix(mix)),
    }
};
 
 
export default connect(mapStateToProps, mapDispatchToProps)(SpotlightTrack);
